"use strict";

exports.__esModule = true;
exports.targetTimeWindowCheck = exports.pivotByTarget = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var pivotByTarget = exports.pivotByTarget = function pivotByTarget(_ref) {
  var tableData = _ref.tableData,
    timeAggregationName = _ref.timeAggregationName,
    shiftAggregationName = _ref.shiftAggregationName,
    kindAggregationName = _ref.kindAggregationName,
    time = _ref.time;
  return function (data) {
    var tableDataIndex = 0;
    var tableDataToReturn = _lodash["default"].cloneDeep(tableData);
    var shouldFilterByShift = shiftAggregationName != null && shiftAggregationName !== "";
    var shouldFilterByKind = kindAggregationName != null && kindAggregationName !== "";
    tableData.forEach(function (tableDataItem) {
      var targetsWithSamePeriod = data.filter(function (item) {
        if (shouldFilterByShift) {
          return item.period === shiftAggregationName.toUpperCase();
        } else if (timeAggregationName === "day") {
          return item.period === timeAggregationName.toUpperCase() || item.period === "WORKDAY";
        }
        return item.period === timeAggregationName.toUpperCase();
      });
      var targetsWithContainingDeviceId = targetsWithSamePeriod.filter(function (item) {
        return item.scope.device_id.includes(tableDataItem.device);
      });
      var targetsWithSameMetrics = targetsWithContainingDeviceId.filter(function (item) {
        return item.metric === tableDataItem.metric;
      });
      var targetsWithDevicesInTimeWindow = targetsWithSameMetrics.filter(function (target) {
        for (var i = 0; i < tableDataItem.datesArray.length; i++) {
          if (targetTimeWindowCheck(target, tableDataItem.datesArray[i], time)) {
            return target;
          }
        }
      });
      var filteredTargets = targetsWithDevicesInTimeWindow;
      if (shouldFilterByShift) {
        filteredTargets = filteredTargets.filter(function (item) {
          return item.scope.shift.includes(tableDataItem[shiftAggregationName]);
        });
      }
      if (shouldFilterByKind) {
        filteredTargets = filteredTargets.filter(function (item) {
          return item.scope.kind_id.includes(tableDataItem[kindAggregationName]);
        });
      }
      for (var i = 0; i < filteredTargets.length; i++) {
        if (i === 0) {
          tableDataToReturn[tableDataIndex] = Object.assign({}, tableDataItem, {
            targetName: filteredTargets[0].name,
            "target.value": filteredTargets[0].targetValue
          });
        } else {
          tableDataToReturn.splice(tableDataIndex, 0, Object.assign({}, tableDataItem, {
            targetName: filteredTargets[i].name,
            "target.value": filteredTargets[i].targetValue
          }));
          tableDataIndex++;
        }
      }
      tableDataIndex++;
    });
    return tableDataToReturn;
  };
};
var targetTimeWindowCheck = exports.targetTimeWindowCheck = function targetTimeWindowCheck(target, deviceTime, time) {
  var _time$timezone, _time$timezone2;
  return _momentTimezone["default"].utc(deviceTime).isBetween(_momentTimezone["default"].tz(target.startWorkday, "YYYY-MM-DD", (_time$timezone = time.timezone) == null ? void 0 : _time$timezone.name), _momentTimezone["default"].tz(target.endWorkday, "YYYY-MM-DD", (_time$timezone2 = time.timezone) == null ? void 0 : _time$timezone2.name), "date", "[]");
};